import { AiFillGithub } from "react-icons/ai";
import { GrLinkedinOption } from "react-icons/gr";

import styles from "./Footer.module.css";
import { IconLink } from "../../components/UI/IconLink/IconLink";

export const Footer = () => {
  return (
    <footer className={`${styles.container} grid`}>
      <div className={styles.subCont}>
        <div className={styles.contTitle}>
          <h1 className={styles.title}>Ahmed Ghanim</h1>
          <span className={styles.subtitle}>Frontend Developer</span>
        </div>

        {/* <ul className={styles.links}>
          <li>
            <a href="#services" className={styles.link}>
              Services
            </a>
          </li>
          <li>
            <a href="#contact" className={styles.link}>
              Contact Me
            </a>
          </li>
        </ul> */}

        <div className={styles.socials}>
          <IconLink
            to="https://github.com/ahmedghanim7"
            Icon={AiFillGithub}
            isExternal={true}
            className={styles.icon}
            aria-label="logo github"
          />
          <IconLink
            to="https://www.linkedin.com/in/ahmed-ghanim/"
            Icon={GrLinkedinOption}
            isExternal={true}
            className={styles.icon}
            aria-label="logo linkedin"
          />
        </div>
      </div>
      <p className={styles.copy}>&#169; All rights reserved - 2024</p>
    </footer>
  );
};
